import { render, staticRenderFns } from "./notes-table.vue?vue&type=template&id=5f26232a"
import script from "./notes-table.vue?vue&type=script&lang=js"
export * from "./notes-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports